"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HID_PRODUCT_ID = exports.WEBUSB_PRODUCT_ID = exports.VENDOR_ID = void 0;
exports.VENDOR_ID = 0x2b24;
exports.WEBUSB_PRODUCT_ID = 0x0002;
exports.HID_PRODUCT_ID = 0x0001;
//# sourceMappingURL=utils.js.map